import { SignatureRequestUserStatus } from "@btnet/services-btnet/handlers/models/signatureRequestUserStatus";

import { type StatusTypes } from "commonComponents/utilities/Status/StatusDisplay";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

interface IUserApprovalStatusProps {
    status: SignatureRequestUserStatus;
}

export function UserApprovalStatusTag({ status }: IUserApprovalStatusProps) {
    let statusType: StatusTypes;
    let statusText: string;

    switch (status) {
        case SignatureRequestUserStatus.Signed:
            statusType = "success";
            statusText = "Approved";
            break;
        case SignatureRequestUserStatus.Declined:
            statusType = "danger";
            statusText = "Declined";
            break;
        case SignatureRequestUserStatus.InternallyApproved:
            statusType = "success";
            statusText = "Internally approved";
            break;
        case SignatureRequestUserStatus.NotApplicable:
            statusType = "";
            statusText = "Not required";
            break;
        default:
            statusType = "pending";
            statusText = "Pending";
            break;
    }

    return <StatusTagDisplay statusText={statusText} statusType={statusType} />;
}
